export const labelsData = [
  { id: 1, name: 'Home' },
  { id: 2, name: 'Work' },
  { id: 3, name: 'Study' },
  { id: 4, name: 'Fun' }
];
